import React from "react";
import type { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { RegisterProvider } from "../../context/RegisterContext";

interface AuthLayoutProps {
  children?: ReactNode;
}

/**
 * AuthLayout: For all auth-related pages. Ensures scrollable content area.
 * - Fills viewport
 * - Main area is scrollable (overflow-auto, flex-1)
 * - Responsive, mobile-friendly
 */
const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <RegisterProvider>
      <div className="flex flex-col">
        <main className="flex-1 overflow-auto overflow-x-hidden min-h-[100dvh]">
          {children ? children : <Outlet />}
        </main>
      </div>
    </RegisterProvider>
  );
};

export default AuthLayout;
